import FooterLogo from "../../images/logo/logo.png";
import { Link } from "react-router-dom";
import {
  FaInstagram,
  FaWhatsapp,
  FaEnvelope,
  FaMapLocationDot,
  FaLocationDot,
  FaPhone,
} from "react-icons/fa6";

function Footer() {
  const mapUrl = "https://www.google.com/maps?q=10.928267478942871,76.98478698730469&z=17&hl=en";

  const goTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <footer className="bg-neutral-950 text-white border-t border-neutral-900">
        <div className="container page-padding py-12 sm:py-16 md:py-20">
          {/* footer grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 text-left">
            {/* logo side */}
            <div className="flex flex-col gap-5">
              <Link to="/" onClick={goTop} className="w-[90px]">
                <img
                  src={FooterLogo}
                  alt="FAT2FIT Logo"
                  className="w-[80px] sm:w-[90px] h-auto object-contain"
                />
              </Link>
              <p className="text-[13px] sm:text-[14px] font-medium text-neutral-400 leading-relaxed">
                FAT2FIT Unisex Fitness Centre – Where Limits Become Legends. Located at Eachanari,
                Coimbatore. Internationally certified coaching &amp; lifestyle transformation.
              </p>
              <p className="text-[12px] sm:text-[13px] font-medium text-neutral-500">
                © {new Date().getFullYear()} FAT2FIT Unisex Fitness Centre
              </p>
            </div>

            {/* Quick links */}
            <div className="flex flex-col gap-3 sm:gap-4 relative">
              <p className="text-[16px] sm:text-[18px] font-bold text-[#ffd600] uppercase tracking-wider mb-1">
                Quick Links
              </p>
              <span className="top-[28px] absolute w-[40px] h-[3px] bg-[#ff0336]"></span>
              <div className="flex flex-col gap-2.5 mt-2">
                <Link to="/about" onClick={goTop} className="text-[14px] hover:text-[#ffd600] text-neutral-400 transition">
                  About Us
                </Link>
                <Link to="/pricing" onClick={goTop} className="text-[14px] hover:text-[#ffd600] text-neutral-400 transition flex items-center gap-1.5">
                  <span>Membership Pricing</span>
                  <span className="bg-[#ff0336] text-[10px] text-white px-1.5 py-0.5 rounded font-bold">
                    Offers
                  </span>
                </Link>
                <Link to="/trainings" onClick={goTop} className="text-[14px] hover:text-[#ffd600] text-neutral-400 transition">
                  Trainings &amp; Services
                </Link>
                <Link to="/equipments" onClick={goTop} className="text-[14px] hover:text-[#ffd600] text-neutral-400 transition">
                  Gym Equipments
                </Link>
                <Link to="/gallery" onClick={goTop} className="text-[14px] hover:text-[#ffd600] text-neutral-400 transition">
                  Gallery
                </Link>
                <Link to="/testimonials" onClick={goTop} className="text-[14px] hover:text-[#ffd600] text-neutral-400 transition">
                  Testimonials
                </Link>
                <Link to="/contact" onClick={goTop} className="text-[14px] hover:text-[#ffd600] text-neutral-400 transition">
                  Contact Us
                </Link>
              </div>
            </div>

            {/* working hours */}
            <div className="flex flex-col gap-3 sm:gap-4 relative">
              <p className="text-[16px] sm:text-[18px] font-bold text-[#ffd600] uppercase tracking-wider mb-1">
                Working Hours
              </p>
              <span className="top-[28px] absolute w-[40px] h-[3px] bg-[#ff0336]"></span>
              <div className="mt-2 flex flex-col gap-2">
                <p className="text-[14px] text-neutral-300 font-bold">Monday – Saturday:</p>
                <p className="text-[14px] text-neutral-400">5:00 AM – 10:00 PM</p>
                <p className="text-[14px] text-[#ff0336] font-bold mt-1">Sunday – Holiday</p>
                <div className="mt-4 pt-4 border-t border-neutral-900">
                  <p className="text-[12px] text-neutral-400">
                    <span className="text-[#ffd600] font-bold">Offers active:</span> Early Bird packages available now at Eachanari!
                  </p>
                </div>
              </div>
            </div>

            {/* contact & socials */}
            <div className="flex flex-col gap-3 sm:gap-4 relative">
              <p className="text-[16px] sm:text-[18px] font-bold text-[#ffd600] uppercase tracking-wider mb-1">
                Contact Us
              </p>
              <span className="top-[28px] absolute w-[40px] h-[3px] bg-[#ff0336]"></span>
              <div className="mt-2 flex flex-col gap-2.5">
                <a
                  href={mapUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="text-[13px] sm:text-[14px] text-neutral-400 hover:text-[#ffd600] transition leading-relaxed flex items-start gap-2"
                >
                  <FaLocationDot className="text-[#ff0336] mt-0.5 shrink-0" />
                  219 F 10/1, Ground Floor, Chettipalayam Road, Eachanari – 641021, Coimbatore
                </a>
                <a
                  href="tel:8637488702"
                  className="text-[13px] sm:text-[14px] hover:text-[#ffd600] text-neutral-400 transition flex items-center gap-2"
                >
                  <FaPhone className="text-[#ff0336] shrink-0" /> +91 86374 88702
                </a>
                <a
                  href="tel:9597557006"
                  className="text-[13px] sm:text-[14px] hover:text-[#ffd600] text-neutral-400 transition flex items-center gap-2"
                >
                  <FaPhone className="text-[#ff0336] shrink-0" /> +91 95975 57006
                </a>
                <a
                  href="mailto:nknandhu.fitness@gmail.com"
                  className="text-[13px] sm:text-[14px] hover:text-[#ffd600] text-neutral-400 transition break-all flex items-center gap-2"
                >
                  <FaEnvelope className="text-[#ff0336] shrink-0" />
                  nknandhu.fitness@gmail.com
                </a>

                {/* Social icons */}
                <div className="flex gap-3 text-[16px] text-white mt-2">
                  <a
                    href="https://www.instagram.com/nk_.nandhu"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="FAT2FIT Instagram"
                    className="bg-neutral-900 border border-neutral-800 p-2.5 rounded-full hover:bg-[#ff0336] transition-all cursor-pointer flex items-center justify-center"
                  >
                    <FaInstagram />
                  </a>
                  <a
                    href="https://wa.me/918637488702"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="FAT2FIT WhatsApp"
                    className="bg-neutral-900 border border-neutral-800 p-2.5 rounded-full hover:bg-[#25D366] transition-all cursor-pointer flex items-center justify-center"
                  >
                    <FaWhatsapp />
                  </a>
                  <a
                    href="mailto:nknandhu.fitness@gmail.com"
                    aria-label="FAT2FIT Email"
                    className="bg-neutral-900 border border-neutral-800 p-2.5 rounded-full hover:bg-[#ff0336] transition-all cursor-pointer flex items-center justify-center"
                  >
                    <FaEnvelope />
                  </a>
                  <a
                    href={mapUrl}
                    target="_blank"
                    rel="noreferrer"
                    aria-label="FAT2FIT Google Maps"
                    className="bg-neutral-900 border border-neutral-800 p-2.5 rounded-full hover:bg-[#ffd600] hover:text-black transition-all cursor-pointer flex items-center justify-center"
                  >
                    <FaMapLocationDot />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
